import React, { useEffect } from "react";

interface Props {
  imageSrc: string;
  placholderImageSrc: string;
}

export const ImageLoader = ({ imageSrc, placholderImageSrc }: Props) => {
  const [currentImageLoaded, setCurrentImageLoaded] =
    React.useState<boolean>(false);
  useEffect(() => {
    const image = document.createElement("img");
    image.src = imageSrc;
    image.onload = () => {
      setCurrentImageLoaded(true);
    };
  }, [imageSrc]);

  return (
    <img
      alt="tribeca-studio-img-player"
      className="img-player-el"
      src={currentImageLoaded ? imageSrc : placholderImageSrc}
      style={{ maxHeight: 850 }}
    />
  );
};
